import React from "react";
import { Avatar, Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import PropTypes from 'prop-types';

/**
 * @param props {{
  anchorEl: any;
  handleMenuClose: () => any,
  accountName?: string;
  user: {
    given_name: string | undefined;
    picture?: string;
    email: string | undefined;
  },
  handleSignIn: () => any,
  handleSignOut: () => any,
  menuId: string,
  additionalUserProfileMenuItems?: JSX.Element[]
 * }}
 */

const UserProfileMenu = ({
  anchorEl,
  handleMenuClose,
  accountName,
  user,
  handleSignIn,
  handleSignOut,
  menuId,
  additionalUserProfileMenuItems
}) => {

  const isMenuOpen = Boolean(anchorEl);

  return (
    <Menu
      anchorEl={anchorEl}
      id={menuId}
      open={isMenuOpen}
      onClose={handleMenuClose}
      onClick={handleMenuClose}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
      {
        user.email &&
        <>
          <Box
            sx={{
              display: 'flex',
              columnGap: '10px',
              maxWidth: '400px',
              height: '68px',
              margin: '-8px 8px 0 8px',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Avatar alt="profile picture" src={user?.picture} sx={{ width: '40px', height: '40px' }} />
            <Box sx={{
              display: 'block',
              maxWidth: '344px',
            }}>
              <Typography variant='body1' >{user?.given_name || 'User name'} {accountName && ('('+(accountName || 'User account')+')')}</Typography>
              <Typography variant='body2' sx={{
                display: 'block',
                minWidth: 0,
                maxWidth: '100%'
              }}
                noWrap
                textOverflow='ellipsis'>{user?.email || 'User email'}</Typography>
              {/* {
                accountName &&
                <Typography variant='body2' sx={{
                  display: 'block',
                  minWidth: 0,
                  maxWidth: '100%'
                }}
                  noWrap
                  textOverflow='ellipsis'>{accountName || 'User account'}</Typography>
              } */}

            </Box>
          </Box>
          <Divider />
        </>
      }

      {
        user.email ?
          <MenuItem onClick={handleSignOut}>Sign Out</MenuItem> :
          <MenuItem onClick={handleSignIn}>Sign In</MenuItem>
      }
      {additionalUserProfileMenuItems.length ? <Divider /> : null}
      {additionalUserProfileMenuItems}
    </Menu>
  );
}

export default UserProfileMenu;

UserProfileMenu.propTypes = {
  anchorEl: PropTypes.any,
  handleMenuClose: PropTypes.func.isRequired,
  accountName: PropTypes.string,
  user: PropTypes.shape({
    given_name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    picture: PropTypes.string
  }).isRequired,
  handleSignIn: PropTypes.func.isRequired,
  handleSignOut: PropTypes.func.isRequired,
  menuId: PropTypes.string.isRequired,
  additionalUserProfileMenuItems: PropTypes.arrayOf(PropTypes.element)
}